import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SiteHeaderComponent } from './site-header/site-header.component';
import { SiteFooterComponent } from './site-footer/site-footer.component';
import { SiteLayoutComponent } from './site-layout/site-layout.component';
import { RouterModule } from '@angular/router';
import { GeneralModule } from '../general/general.module';
import { CryptoPricesComponent } from './crypto-prices/crypto-prices.component';
import { BlogPostsComponent } from './blog-posts/blog-posts.component';
import { StartStepsComponent } from './start-steps/start-steps.component';
import { AffiliateRewardsComponent } from './affiliate-rewards/affiliate-rewards.component';
import { GetStartedComponent } from './get-started/get-started.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MarketTickerComponent } from './market-ticker/market-ticker.component';
import { BitoasisFeaturesComponent } from './bitoasis-features/bitoasis-features.component';
import { CryptoListItemComponent } from './crypto-list-item/crypto-list-item.component';
import { CryptoPageDetailComponent } from './crypto-page-detail/crypto-page-detail.component';
import { CurrencyHowToBuyComponent } from './crypto-page-detail/currency-how-to-buy/currency-how-to-buy.component';
import { CurrencyWhyTradeComponent } from './crypto-page-detail/currency-why-trade/currency-why-trade.component';
import { CurrencyFaqsComponent } from './crypto-page-detail/currency-faqs/currency-faqs.component';
import { PriceAlertModule } from '../price-alert/price-alert.module';
import { PageHeaderComponent } from './page-header/page-header.component';
import { NavigationModule } from '../navigation/navigation.module';
import { PipesModule } from '../pipes/pipes.module';

@NgModule({
  declarations: [
    SiteLayoutComponent,
    SiteHeaderComponent,
    SiteFooterComponent,
    CryptoPricesComponent,
    BlogPostsComponent,
    StartStepsComponent,
    AffiliateRewardsComponent,
    GetStartedComponent,
    BitoasisFeaturesComponent,
    CryptoListItemComponent,
    CryptoPageDetailComponent,
    CurrencyHowToBuyComponent,
    CurrencyWhyTradeComponent,
    CurrencyFaqsComponent,
    PageHeaderComponent,
    MarketTickerComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    GeneralModule,
    PriceAlertModule,
    NavigationModule,
    PipesModule
  ],
  exports: [
    SiteLayoutComponent,
    SiteHeaderComponent,
    SiteFooterComponent,
    CryptoPricesComponent,
    BlogPostsComponent,
    StartStepsComponent,
    AffiliateRewardsComponent,
    GetStartedComponent,
    BitoasisFeaturesComponent,
    CryptoPageDetailComponent,
    PageHeaderComponent,
    MarketTickerComponent,
  ]
})
export class FrontComponentsModule { }
